var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.4143L10.2929 6.70711C10.6834 7.09763 11.3166 7.09763 11.7071 6.7071C12.0976 6.31657 12.0976 5.68341 11.7071 5.29288L6.7071 0.292988C6.31658 -0.0975261 5.68342 -0.0975261 5.2929 0.292988L0.2929 5.29289C-0.0976278 5.68341 -0.0976345 6.31657 0.292886 6.7071C0.683406 7.09763 1.31657 7.09763 1.7071 6.70711L6 2.4143Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.5a8dc60a0c1546654215bfd8ba00805e.svg";
export { ForwardRef as ReactComponent };